import { AssetClass, IntensityMetric } from "../../models/dto/cat15/cat15.types";

const ASSET_CLASS_LABEL_KEY: Record<AssetClass, string> = {
  business: "Asset-Business-Loans",
  listed: "Asset-Listed-Equity",
  project: "Asset-Project-Finance",
};

/** i18n key for an asset class; an unknown class falls back to its raw code, never another class's label. */
export const assetClassLabelKey = (assetClass: AssetClass): string =>
  ASSET_CLASS_LABEL_KEY[assetClass] ?? assetClass;

const INTENSITY_METRIC_LABEL_KEY: Record<IntensityMetric, string> = {
  outstanding: "Metric-Outstanding",
  revenue: "Metric-Revenue",
  equity: "Metric-Equity",
  evic: "Metric-Evic",
};

/** The intensity bases in the order every selector lists them, outstanding (the default) first. */
export const INTENSITY_METRICS = Object.keys(INTENSITY_METRIC_LABEL_KEY) as IntensityMetric[];

/** i18n key for an intensity basis; an unknown basis falls back to its raw code, never another basis's label. */
export const intensityMetricLabelKey = (metric: IntensityMetric): string =>
  INTENSITY_METRIC_LABEL_KEY[metric] ?? metric;

const INTENSITY_METRIC_DESC_KEY: Record<IntensityMetric, string> = {
  outstanding: "Basis-Desc-Outstanding",
  revenue: "Basis-Desc-Revenue",
  equity: "Basis-Desc-Equity",
  evic: "Basis-Desc-Evic",
};

/** i18n key for the one-line explanation in the basis menu; empty for an unknown basis, so nothing is invented. */
export const intensityMetricDescKey = (metric: IntensityMetric): string =>
  INTENSITY_METRIC_DESC_KEY[metric] ?? "";

/** A section's name in the page language, else the other language; a row without a section code is unclassified. */
export const sectionLabel = (
  row: { sectionCode?: string; sector: string; sectorTh?: string },
  language: string,
  unclassified: string,
): string => {
  if (!row.sectionCode) return unclassified;
  return language.includes("th") ? row.sectorTh || row.sector : row.sector || row.sectorTh || "";
};
